// extracted by css-extract-rspack-plugin
export default {"form":"form-a733NH","note":"note-VeHuaP","loader":"loader-XrutbQ"};